import type { QuoteDocument, OptionsDocument } from 'paintscout'
import type { QuoteItemSection, UpdateableItem } from '../../../types'
import { getArea } from '../../../areas/get-area/get-area'
import { getLineItem } from '../../../line-items/get-line-item/get-line-item'
import { getSubstrate } from '../../../substrates/get-substrate/get-substrate'
import { getGroup } from '../../../groups/get-group/get-group'

export function getItem(args: {
  quote: QuoteDocument
  options: OptionsDocument
  key: string
  sectionOverride?: QuoteItemSection
}): UpdateableItem {
  const { quote, key, sectionOverride } = args

  if (!key) {
    return null
  }

  const sanitizedKey = key.trim().toLowerCase()

  if (quote.areas[key]) {
    return getArea({ ...args, trimBySubstrateSection: sectionOverride })
  } else if (quote.lineItems?.[key]) {
    return getLineItem(args)
  } else if (quote.substrates?.[sanitizedKey]) {
    return getSubstrate(args)
  } else if (quote.groups?.[key]) {
    return getGroup(args)
  }
  return null
}
